<script setup lang="ts">
useHead({
  script: [
    {
      src: 'https://cdn.jsdelivr.net/gh/altcha-org/altcha@main/dist/altcha.min.js',
      type: 'module',
      async: true,
      defer: true
    }
  ]
})

const { t, locale } = useI18n()

interface AltChaEvent extends Event {
  detail: {
    state: string
    payload: string
  }
}

const props = defineProps<{
  show?: boolean
}>()


const emit = defineEmits<{
  verified: [value: string]
}>()

const altcha = ref<HTMLElement|undefined>()

const localeStrings = computed(() => {
  if (locale.value === 'en') return null

  return JSON.stringify({
    error: t('altcha.error'),
    label: t('altcha.label'),
    verified: t('altcha.verified'),
    verifying: t('altcha.verifying'),
    waitAlert: t('altcha.waitAlert')
  })
})

function addCaptchaListener() {
  if (!altcha.value) return
  altcha.value.addEventListener('statechange', (event) => {
    const altchaEvt = event as AltChaEvent

    if (altchaEvt.detail.state === 'verified') {
      emit('verified', altchaEvt.detail.payload)
    }
  })
}

onMounted(() => {
  addCaptchaListener()
})

onUpdated(() => {
  addCaptchaListener()
})
</script>

<template>
  <div v-if="props.show" class="captcha actions">
    <altcha-widget
      :strings="localeStrings"
      ref="altcha"
      class="altcha-widget"
      challengeurl="/api/captcha"
      name="altcha"
      hidelogo
    />
  </div>
</template>

<style lang="scss">
:root {
  --altcha-border-radius: 1rem;
}
</style>

<style scoped lang="scss">
.actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
}
</style>
